// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cfdfee52","523":"ef3cfded","689":"3c9100b8","703":"da60ed5b","716":"b3de1850","943":"02956cd1"}[chunkId] + ".chunk.js";
};